import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';

@Injectable({
  providedIn: 'root'
})
export class WhatAppConfigService {
  get baseUrl(): string { return Constants.CORE_API_BASE_URL; }
  constructor(private http: HttpClient) { }

  getGroups(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Common/GetGroup', data);
  }

  getPlantData(data: any): Observable<any[]> {

    return this.http.post<any[]>(this.baseUrl + 'Common/GetDepartments', data);
  }

  CreateWhatAppConfig(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'WhatAppConfig/AddWhatAppConfig', data);
  }
  UpdateWhatAppConfig(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'WhatAppConfig/UpdateWhatAppConfig', data);
  }
  DeleteWhatAppConfig(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'WhatAppConfig/DeleteWhatAppConfig', data);
  }
  async GetWhatAppConfigList(data: any): Promise<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'WhatAppConfig/GetAllWhatAppConfig', data).toPromise();
  }
  async GetWhatAppConfigInfoList(data: any): Promise<any[]> {

    return await this.http.post<any[]>(this.baseUrl + 'WhatAppConfig/GetWhatAppInfo', data).toPromise();

  }

}
